import React from 'react';
import {HangboardDisplay} from '../../assets/hangboards/hangboardDisplay';

const Hangboard = () => {
  return(
    <>
      {/* <HangboardDisplay name='beastmaker1000'/> */}
      <HangboardDisplay name='trango'/>
      {/* <HangboardDisplay name='trango'/> */}
    </>
    
  )
}
export default Hangboard;